<div class="view-home">
    <section class="landing">
        <div class="frow">
            <div class="col-sm-1-2  frow centered lead">
                <h1 class="text-center mb-20">Fuking Tezzardz</h1>
                <div class="landing-text">
                    <p>Snazzy Fukkrs On The Tezos Blockchain</p>
                    <p class="author">Hand Illustrated By George Goodwin (<a target="_blank"
                            href="https://www.twitter.com/omgidrawedit">@omgidrawedit</a>)</p>
                </div>

            </div>
            <div class="col-sm-1-2 frow centered">
                <div class="preview-img">
                    <img src="/assets/tezzardz.gif">
                </div>

            </div>

        </div>

    </section>

    <section class="crowdsale">
        <h3 class="mb-30">Adopt A Fuking Tezzardz <span *ngIf="hasCountdown">in</span>
        </h3>





        <div class="adopt-area mt-30 frow">
            <div class="text-center">
                <img class="egg-chamber" src="assets/egg_chamber.png">
            </div>
            <ng-container *ngIf="!hasCountdown; else countDown">
                <div class="adoption-area" *ngIf="hasTezzardz$ | async; else mintingDone">
                    <h5 class="mb-10">{{ (tezzardzAdopted$ | async) | number:'1.0-2' || '?' }} of {{ totalTezzardz |
                        number:'1.0-2'}} <small>Tezzardz
                            Have Been
                            Adopted.</small>
                    </h5>
                    <div class="progress-bar mb-40">
                        <ng-container *ngIf="(tezzardzAdopted$ | async) as adopted">
                            <div class="bar" [ngStyle]="{width: adopted / totalTezzardz * 100 + '%'}"></div>
                        </ng-container>
                    </div>
                    <div class="range-slider" *ngIf="(tezzardzAdopted$ | async) as adopted">
                        <input class="range-slider__range" type="range" [(ngModel)]="tezzardzToAdopt" min="1"
                            [max]="Math.min(10, totalTezzardz - adopted)" step="1">
                    </div>
                    <div class="frow justify-between">
                        <button class="mb-15" style="width: 254px;" (click)="adopt()">Adopt {{ tezzardzToAdopt }} Fukr{{
                            tezzardzToAdopt > 1 ?
                            's' : '' }}</button>
                        <ng-container *ngIf="(tezzardzAdopted$ | async) as adopted">
                            <p class="mb-10">You are adopting <span style="font-weight: 900; font-size: 2.2rem;">{{
                                    tezzardzToAdopt }} {{ tezzardString }}</span> for <span
                                    style="font-weight: 900; font-size: 2.2rem;">{{
                                    tezzardzToAdopt * price | number:'1.0-2' }} <app-tez></app-tez></span></p>
                        </ng-container>
                    </div>

                </div>

                <ng-template #mintingDone>
                    <div class="adoption-area">
                        <h5>All Tezzardz have been adopted!</h5>
                        <p>You can view the entire collection on: <a
                                href="https://objkt.com/collection/tezzardz">https://objkt.com/collection/tezzardz</a>
                        </p>
                    </div>
                </ng-template>

            </ng-container>

            <ng-template #countDown>
                <div class="adoption-area">
                    <div class="countdown pt-40 width-100" *ngIf="countdown$ | async as time">
                        <div class="frow row-start timer-wrapper width-100 justify-around">
                            <div class="frow column-start">
                                <h3>{{ time.days }}</h3>
                                <span class="time-label hidden-xs">days</span>
                                <span class="time-label visible-xs">d</span>
                            </div>
                            <div class="frow column-start">
                                <h3>{{ time.hours }}</h3>
                                <span class="time-label hidden-xs">hours</span>
                                <span class="time-label visible-xs">h</span>
                            </div>
                            <div class="frow column-start">
                                <h3>{{ time.minutes }}</h3>
                                <span class="time-label hidden-xs">minutes</span>
                                <span class="time-label  visible-xs">m</span>
                            </div>
                            <div class="frow column-start">
                                <h3>{{ time.seconds }}</h3>
                                <span class="time-label hidden-xs">seconds</span>
                                <span class="time-label  visible-xs">s</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>

        </div>

    </section>

    <section class="examples">
        <div class="frow gutters">
            <div class="col-sm-1 col-md-1-2">
                <h4>What Are Tezzardz?</h4>
                <p>Tezzardz is a collection of programmatically, randomly generated snazzy little fukrs on the Tezos
                    blockchain. Each and every one of these horrible little buggers is unique and illustrated by hand.
                </p>
                <p>The Tezzardz collection consists of {{ totalTezzardz | number:'1.0-2' }} pieces. Each piece is a
                    combination of 97 hand-drawn traits, putting the possibilities into the billions.
                    In addition, 6 super rare 1/1 hand-drawn Tezzardz are hidden within the collection.
                </p>
            </div>

            <div class="col-sm-1 col-md-1-2 frow tezzard-preview">
                <div class="col-md-1-3 col-sm-1-3 col-xs-1-2 tezzard-img-wrapper">
                    <img src="/assets/tezzard-001.png">
                </div>
                <div class="col-md-1-3 col-sm-1-3 col-xs-1-2 tezzard-img-wrapper">
                    <img src="/assets/tezzard-002.png">
                </div>
                <div class="col-md-1-3 col-sm-1-3 col-xs-1-2 tezzard-img-wrapper">
                    <img src="/assets/tezzard-003.png">
                </div>
                <div class="col-md-1-3 col-sm-1-3 col-xs-1-2 tezzard-img-wrapper">
                    <img src="/assets/tezzard-004.png">
                </div>
                <div class="col-md-1-3 col-sm-1-3 col-xs-1-2 tezzard-img-wrapper">
                    <img src="/assets/tezzard-005.png">
                </div>
                <div class="col-md-1-3 col-sm-1-3 col-xs-1-2 tezzard-img-wrapper">
                    <img src="/assets/tezzard-006.png">
                </div>
            </div>
        </div>

    </section>

    <section class="testimonials">
        <h4>Testimonials</h4>
        <div class="testimonials frow gutters centered">
            <div class="col-md-1-3">
                <p class="quote" style="font-size: 1.8rem">If you don't own a Tezzardz you are ngmi!</p>
                <a target="_blank" href="https://twitter.com/chriswallace"
                    class="author frow justify-start width-100 centered">
                    <img src="/assets/chris.jpeg">
                    <div class="frow direction-column ml-20">
                        <h4>Chris Wallace</h4>
                        <p class="title">Jpeg Dealer</p>
                    </div>
                </a>
            </div>
            <div class="col-md-1-3">
                <p class="quote" style="font-size: 1.8rem">Not even I can fud these!</p>
                <a target="_blank" href="https://twitter.com/digitalartchick"
                    class="author frow justify-start width-100 centered">
                    <img src="/assets/artchick.jpeg">
                    <div class="frow direction-column ml-20">
                        <h4>artchick.eth</h4>
                        <p class="title">The Boss</p>
                    </div>
                </a>
            </div>
            <div class="col-md-1-3">
                <p class="quote">TEZZARDALICIOUS!</p>
                <a target="_blank" href="https://twitter.com/jesse_altman"
                    class="author frow justify-start width-100 centered">
                    <img src="/assets/jesse.jpeg">
                    <div class="frow direction-column ml-20">
                        <h4>Jesse Altman</h4>
                        <p class="title">Rare NFT Connaisseur</p>
                    </div>
                </a>
            </div>
            <div class="col-md-1-3">
                <p class="quote" style="font-size: 2rem;">Wtf have you done!?!</p>
                <a target="_blank" href="https://twitter.com/Brekkyalford"
                    class="author frow justify-start width-100 centered">
                    <img src="/assets/brekky.jpeg">
                    <div class="frow direction-column ml-20">
                        <h4>Rebecca Alford</h4>
                        <p class="title">Omg’s gf</p>
                    </div>
                </a>
            </div>

            <!-- <div class="col-md-1-3">
                <p class="quote">WAGMI!</p>
                <a target="_blank" href="https://twitter.com/jjjjjjjjjjohn"
                    class="author frow justify-start width-100 centered">
                    <img src="https://pbs.twimg.com/profile_images/1415066315195355139/7_Q69--M_400x400.jpg">
                    <div class="frow direction-column ml-20">
                        <h4>John Karel</h4>
                        <p class="title">homemade CGI</p>
                    </div>
                </a>
            </div> -->
            <div class="col-md-1-3">
                <p class="quote">RAWRZZ!</p>
                <a target="_blank" href="https://objkt.com/asset/hicetnunc/190739"
                    class="author frow justify-start width-100 centered">
                    <img src="/assets/tezzard7.jpg">
                    <div class="frow direction-column ml-20">
                        <h4>Tezzardz #7</h4>
                        <p class="title">Fukr</p>
                    </div>
                </a>
            </div>
        </div>
    </section>

    <section class="faq">
        <h4 class="mb-40">Tell me more!
        </h4>
        <div class="frow gutters">

            <div class="col-md-1-2">
                <p class="mt-0">One starry night, George Goodwin (aka @omgidrawedit), who is a local Tezzardz breeder
                    got wind of a
                    break in
                    at his hatchery. The intruder, unbeknownst to him at the time, wasn’t planning to steal his Tezzardz
                    but was
                    after their DNA.
                </p>
                <p>After the intruder had already vanished, George asked his riled up Tezzardz about the break-in and
                    was given the description depicted in the sketch. We CIA-d the fuk out of it and
                    have
                    identified the Tezzardz in the right picture.</p>
            </div>
            <div class="col-md-1-2">
                <img class="width-100" src="/assets/tezzard-drawing.jpg">
            </div>
        </div>
        <p>A horrible little fukr. It is rumoured that the dev they are carrying in their bag is from objkt.com and
            enabled some horrible things to happen. They ended up using the original Tezzardz DNA to create many
            more, slightly different Tezzardz clones. A New Breed. A whole colony of these PRIKS!!</p>
        <h5 class="mt-40">No, but wtf what is this?
        </h5>
        <p>Horrible little generative fukrs, mintable on Tezos, cheekily rocking their own FA2 token. These fukrs
            claim to be the first provably limited generative profile picture drop on Tezos.</p>
        <h5 class="mt-40">How do you ensure a fair distribution of these fkrs?
        </h5>
        <p>
            The contract contains a provenance hash (An IPFS-hash that points to a document containing a mapping
            from token ids to a fingerprint of the art). This allows anyone to verify that we didn’t assign Tezzardz
            after minting them. Furthermore, at the start of the sale, the harbinger price oracle
            (<a target="_blank" href="https://harbinger.live/">https://harbinger.live/</a>) is used to randomize the
            starting id of the sale.
        </p>
        <h5 class="mt-40">What happens after I mint?
        </h5>
        <p>After you mint your Tezzardz, the tokens will be visible in your wallet and in your objkt.com collection
            page. Initially, you will only see the egg and all traits will be hidden. It’s only after the sale ends,
            that the actual Tezzardz will be revealed to you. It is planned for this to happen one day after the sale is
            over. </p>
        <h5 class="mt-40">How many fukrs can be minted per wallet?</h5>
        <p>According to the breeder George, Tezzardz are social animals, that’s why we allow you to mint a whole lounge
            of them at once. They can be a handful though. We noticed that in bigger groups, they do tend to end up
            fighting each other. That’s why we decided to limit the amount of Tezzardz that can be bought at a time to
            10, for your own and the little Fukrs safety.
        </p>
        <h5>Where can the fukrs be traded?</h5>
        <p>The Tezzardz FA2 tokens have their own collection on <a
                href="https://objkt.com/collection/tezzardz">objkt.com</a> and can be traded there.
        </p>
        <h5 class="mt-40">Will we be able to breed Tezzardz in the future?
        </h5>
        <p>Are you out of your mind!?</p>
    </section>

    <section class="roadmap">
        <h4>Roadmap</h4>
        <p>There is no roadmap, lolz. You buy the Tezzardz for the art. There may or may not be benefits for holders
            down
            the line.</p>
    </section>

    <section class="roadmap">
        <h4>Provenance</h4>
        <p>Ipfs Hash: <a target="_blank"
                href="https://ipfs.io/ipfs/QmYZPNzf2dgQoek9PMc4ZtPoaGB6hWnibKw95NaLDMGgp5">QmYZPNzf2dgQoek9PMc4ZtPoaGB6hWnibKw95NaLDMGgp5</a>
        </p>
        <p>Contract: <a target="_blank"
                href="https://better-call.dev/mainnet/KT1DdxmJujm3u2ZNkYwV24qLBJ6iR7sc58B9">KT1DdxmJujm3u2ZNkYwV24qLBJ6iR7sc58B9</a>
        </p>
    </section>

    <section class="social">
        <h4 class="mb-20">Join Our Discord To Get More Information And The Latest Updates</h4>
        <button><a target="_blank" href="https://discord.gg/ex5BDgx8Jc">Join Discord</a></button>
    </section>

</div>